// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ce","title":"de"};